import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from './Header';
import { HelmetProvider } from 'react-helmet-async';

import Home from './components/Home';
import Rashifal from './components/Rashifal';
// import TajaKhabr from './components/TajaKhabr';
import LiveNews from './components/LiveNews';
import Footer from './components/Footer';
import Webstorie from './components/Webstorie';
import MpNews from './components/MpNews';
// import HealthAndFitness from './components/HealthAndFitness';
import ScrollToTop from './components/ScrollToTop';
// import Sports from './components/Sports';
// import Card from './components/Card';
import SliderDetails from './components/SliderDetails';
import TajaKhabarDetails from './components/TajaKhabarDetails';
import TajaKhabarDetailsNews from './components/TajaKhabarDetailsNews';
import CommonNewsDetailsPage from './components/CommonNewsDetailsPage';
import RashifalDetails from './components/RashifalDetails';
import WebstorieDetails from './components/WebstorieDetails';
import VideoDetails from './components/VideoDetails';
import DaramDetails from './components/DaramDetails';
import KhelDetails from './components/KhelDetails';
import BuisnessDetails from './components/BuisnessDetails';
import ChhatisgarDetails from './components/ChhatisgarDetails';
import RashiDetail from './components/RashiDetail';
import BusinessDetailsD from './components/BusinessDetailsD';
import StateNewsCard from "./components/StateNewsDetails";
import Khels from './components/Khels';
// import KhelDetailsD from './components/KhelDetailsD';
import Bollywood from './components/Bollywood';
// import BollywoodDetails from './components/BollywoodDetails';
import VideoDetailsD from './components/VideoDetailsD';
import DaramDetailsD from './components/DaramDetailsD';
// import ScrollTo from './components/ScrollTo';
import WebStrorieD from './components/WebStrorieD';
import DainikRashifalDetails from './components/DainikRashifalDetails';
// import International from './components/International';
// import InternationalDetails from './components/InternationalDetails';
import MadhyaPradeshDetails from './components/MadhyaPradeshDetails';
// import MadhyapradeshDetailsD from './components/MadhyapradeshDetailsD';
// import OtherState from './components/OtherState';
// import OtherStateNewsCard from './components/OtherStateNewsCard';
// import OtherStateDetails from './components/OtherStateDetails';
// import ChhatisgarDetailsD from './components/ChhatisgarDetailsD';
import RashifalDetailsD from './components/RashifalDetailsD';
// import Wether from './components/Wether';
import Epaper from './components/Epaper';
import PdfViewer from './components/PdfViewer';
import EpaperDetails from './components/EpaperDetails';
// import DemoD from './components/DemoD';
import NotFound from './components/NotFound';
import World from './components/World';
import WorldD from './components/WorldD';
import TechnologyDetails from './components/TechnologyDetails';
// import TechnonlogyD from './components/TechnologyD';
import PoliticsPage from './components/PoliticsPage';
// import PoliticsD from './components/PoliticsD';
import NationalPage from './components/NationalPage';
import NationalD from './components/NationalD';
// import PhotoMovieGalleryPage from './components/PhotomovieGalleryPage';
import LifeStyle from './components/LifeStyle';
import OpinionPage from './components/OpinionPage';
import OpinionDetails from './components/Opinion_Details';
import OpinionWithIdPage from './components/OpinionWithIdPage';
import Viewer from './components/viewer';
import JanSampark from './components/JanSamparkRSS';
import CookieConsentBanner from './components/CookieConsentBanner';
import PrivacyPolicy from './components/PrivacyPolicy';
import Contact from './components/Contact';

function App() {
  const location = useLocation();

  const shouldRenderHeaderFooter = (path) => {
    const excludedPaths = ['/WebStrorieD', '/Epaper', '/pdf'];
    return !excludedPaths.some(excludedPath => path.startsWith(excludedPath));
  };

  return (
    <>
      {shouldRenderHeaderFooter(location.pathname) && <Header />}
      {/* <ScrollTo /> */}
      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/Card" element={<Card />} /> */}
        {/* <Route path="/TajaKhabr" element={<TajaKhabr />} /> */}
        <Route path="/MpNews" element={<MpNews />} />
        {/* <Route path="/Sports" element={<Sports />} /> */}
        {/* <Route path="/Slider-News/:mainKhabarId" element={<SliderDetails />} /> */}
        <Route path="/TajaKhabar-News" element={<TajaKhabarDetails />} />
        {/* <Route path="/TajaKhabar-News/:mainKhabarId" element={<TajaKhabarDetailsNews />} /> */}
        <Route path="/News-Details/:mainKhabarId" element={<CommonNewsDetailsPage />} />
        <Route path="/MadhyaPradesh-News" element={<MadhyaPradeshDetails />} />
        {/* <Route path="/MadhyaPradesh-News/:mainKhabarId" element={<MadhyapradeshDetailsD />} /> */}
        <Route path="/Rashifal-News" element={<Rashifal />} />
        <Route path="/Rashifal-News/:mainKhabarId" element={<RashiDetail />} />
        <Route path="/Daram-News" element={<DaramDetails />} />
        <Route path="/Daram-News/:mainKhabarId" element={<DaramDetailsD />} />
        <Route path="/KhelDetails" element={<KhelDetails />} />
        <Route path="/Chhattisgarh-News" element={<ChhatisgarDetails />} />
        {/* <Route path="/Chhattisgarh-News/:mainKhabarId" element={<ChhatisgarDetailsD />} /> */}
        <Route path="/Buisness-News" element={<BuisnessDetails />} />
        {/* <Route path="/Business-News/:mainKhabarId" element={<BusinessDetailsD />} /> */}
        <Route path="/Khel-News" element={<Khels />} />
        {/* <Route path="/Khel-News/:mainKhabarId" element={<KhelDetailsD />} /> */}
        <Route path="/Bollywood-News" element={<Bollywood />} />
        {/* <Route path="/Bollywood-News/:mainKhabarId" element={<BollywoodDetails />} /> */}
        <Route path="/Video-News" element={<VideoDetails />} />
        <Route path="/Video-News/:shortVideoId" element={<VideoDetailsD />} />
        <Route path="/Webstorie-News" element={<WebstorieDetails />} />
        <Route path="/WebStrorie-News/:webStoriesId" element={<WebStrorieD />} />
        {/* <Route path="/International-News" element={<International />} /> */}
        {/* <Route path="/International-News/:mainKhabarId" element={<InternationalDetails />} /> */}
        {/* <Route path="/OtherState-News/:stateId" element={<OtherState />} />
        <Route path="/OtherState-News" element={<OtherStateNewsCard />} /> */}
        <Route path="/OtherState-News/:slug" element={<StateNewsCard />} />
        {/* <Route path="/Other-State-News/:mainKhabarId" element={<OtherStateDetails />} /> */}
        <Route path="/Live-News" element={<LiveNews />} />
        <Route path="/Epaper-News" element={<Epaper />} />
        <Route path="/pdf-viewer" element={<PdfViewer />} />
        <Route path="/Epaper-News/:epaperId" element={<EpaperDetails />} />
        {/* <Route path="/DemoD" element={<DemoD />} /> */}
        <Route path="/World-News" element={<World />} />
        {/* <Route path="/World-News/:mainKhabarId" element={<WorldD />} /> */}
        <Route path="/Technology-News" element={<TechnologyDetails />} />
        {/* <Route path="/Technology-News/:mainKhabarId" element={<TechnonlogyD />} /> */}
        <Route path="/Politics-News" element={<PoliticsPage />} />
        {/* <Route path="/Politics-News/:mainKhabarId" element={<PoliticsD />} /> */}
        <Route path="/National-News" element={<NationalPage />} />
        {/* <Route path="/National-News/:mainKhabarId" element={<NationalD />} /> */}
        <Route path="/LifeStyle-News" element={<LifeStyle />} />
        <Route path="/Opinions" element={<OpinionPage />} />
        <Route path="/Opinions_Details/:mainKhabarId" element={<OpinionDetails />} />
        <Route path="/OpinionAccordingTomember/:id" element={<OpinionWithIdPage />} />
        <Route path="/pdf/:id" element={<Viewer />} />
        <Route path="/jansampark" element={<JanSampark />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/contactUs" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {shouldRenderHeaderFooter(location.pathname) && <Footer />}
      <ScrollToTop />
    </>
  );
}

function AppWrapper() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <App />
        <CookieConsentBanner />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default AppWrapper;
